<template>
  <div :class="mainStyle">
    <div :class="$style.kioskAuthHeader">
      <div :class="$style.buttonWrapper">
        <BaseButton
          v-if="showBackButton"
          :class="[$style.navBtn, $style.backBtn]"
          button-style="Back"
          @click="back"
        >
          <svg v-svg
               :class="$style.backIcon"
               symbol="straight-arrow" />
          <span>Back</span>
        </BaseButton>
      </div>

      <Logo />

      <div :class="$style.buttonWrapper">
        <BaseButton
          v-if="showNextButton"
          :class="[$style.navBtn, $style.nextBtn]"
          :disabled="nextDisabled"
          button-style="Main"
          @click="next"
        >
          <span>Next</span>
          <svg v-svg
               :class="$style.nextIcon"
               symbol="straight-arrow" />
        </BaseButton>
      </div>
    </div>

    <div :class="$style.kioskAuthMain">
      <span v-if="isNew"
            :class="$style.newLabel">New</span>
      <div :class="$style.kioskAuthTitle">
        <span :class="$style.titleLine" />
        <h2>{{ title }}</h2>
        <span :class="$style.titleLine" />
      </div>

      <slot />
    </div>

    <KioskTryBlock />
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import KioskLayout from '@/layouts/KioskLayout';
import Logo from '@/components/Logo';
import BaseButton from '@/components/BaseButton';
import KioskTryBlock from '@/components/KioskTryBlock';
import { ROUTES_WITHOUT_HEADER } from '@/apps/kiosk/constants';

/* Provide layout to kiosk authorization screens */
@Component({
  components: {
    KioskLayout,
    Logo,
    BaseButton,
    KioskTryBlock,
  },
  props: {
    title: {
      type:     String,
      required: false,
      default:  '',
    },
    isNew: {
      type:     Boolean,
      required: false,
      default:  false,
    },
    showBackButton: {
      type:     Boolean,
      required: false,
      default:  false,
    },
    showNextButton: {
      type:     Boolean,
      required: false,
      default:  false,
    },
    nextDisabled: {
      type:     Boolean,
      required: false,
      default:  false,
    },
  },
})
export default class KioskAuthLayout extends Vue {
  back() {
    this.$emit('back');
  }
  next() {
    this.$emit('next');
  }

  get mainStyle() {
    const styles = [
      this.$style.kioskAuth,
    ];

    if (ROUTES_WITHOUT_HEADER.includes(this.$router.currentRoute.name)) {
      styles.push(this.$style.kioskHeadless);
    }

    return styles;
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';
@import '@/style/helpers.scss';

.kioskAuth {
  display: flex;
  flex-direction: column;
  height: calc(100vh - #{$kioskHeaderHeight});
  min-height: calc(1920px - #{$kioskHeaderHeight});
  background-color: $white;
}

.kioskHeadless {
  height: 100vh;
  min-height: 1920px;
}

.kioskAuthHeader {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 50px 50px 0;
  .buttonWrapper {
    width: 183px;
  }
  button.navBtn {
    width: 183px;
    height: 100px;
    border-radius: 50px;
    margin: 24px 0 0;
    .nextIcon,
    .backIcon {
      width: 28px;
      height: 33px;
    }
  }
}

.kioskAuthMain {
  display: flex;
  flex-direction: column;
  padding: 0 50px;
  flex: 1 1 0;
}

.backBtn {
  .backIcon {
    fill: $black-slightly-transparent;
  }
  span {
    padding-left: 13px;
  }
}

.nextBtn {
  .nextIcon {
    transform: rotateY(180deg);
    fill: $white;
  }
  span {
    padding-right: 5px;
  }
}

.kioskAuthTitle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
  .titleLine {
    width: 120px;
    height: 7px;
    background-color: $green-color;
  }
  h2 {
    font-weight: 700;
    font-size: 48px;
    line-height: 44px;
    text-transform: uppercase;
    margin: 0 50px;
  }
}

.newLabel {
  display: block;
  width: 76px;
  height: 39px;
  margin: 0 auto;
  background-color: $green-color;
  color: $white;
  font-size: 21.56px;
  line-height: 39px;
  font-weight: 700;
  border-radius: 19.4px;
  text-transform: uppercase;
  text-align: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/KioskAuthLayout.vue